<template>
  <el-container height="auto" style="overflow:hidden;">
    <el-header style="margin:0px;padding:0px;padding-bottom:5px;height:35px;">
          <el-row type="flex" justify="end">
            <el-col :span="12">
              <el-link  style="font-size:16px;color:#409EFF;" :underline="false" @click="reloadList">
                我的团队
                <i class="el-icon-refresh el-icon--right" style="font-size:20px;"></i>
              </el-link>
              <!-- <el-divider direction="vertical"></el-divider>
              <el-link  @click="$router.push({path:'/home/projectform'})" style="font-size:16px;" :underline="false" >表单</el-link> -->
            </el-col>
            <el-col :span="12" style="text-align:right;padding-right:15px;">

              <!-- <el-button type="primary" size="mini" @click="createProject()">新建研究</el-button> -->
              <!-- &nbsp; -->

              <el-input v-model="invitecode" placeholder="请输入邀请码,后回车" size="mini" style="width:200px;height:20px;"
              @keyup.enter.native="acceptinvite"
              ></el-input>
              <el-button type="primary" size="mini" @click="acceptinvite()">接受</el-button>
              &nbsp;&nbsp;&nbsp;&nbsp;

              <el-popover
                placement="bottom"
                title=""
                width="400"
                trigger="click"
                style="cursor:pointer;"
                @show="showfilter"
                >
                <el-input
                    ref="searchinput"
                    placeholder="输入团队名称进行搜索"
                    prefix-icon="el-icon-search"
                    v-model="search"
                    clearable
                    >
                  </el-input>

               <el-link slot="reference" :underline="false">
                  {{(this.search != '') ?'已筛选':'筛选'}}
                  <i class="fa fa-filter" style="font-size:20px;"></i>
                </el-link>
              </el-popover>
            </el-col>
          </el-row>
        </el-header>
    <el-main style="margin:0px;padding:0px;">
      <el-table 
          v-loading="loading" 
          element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background=""
          :empty-text="emptytext"
          :data="filterProjectList.slice((currentPage1-1)*pageSize1,currentPage1*pageSize1)" :show-header="false">
        <el-table-column label="名称"  prop="scope.row.name">
       
          <template slot-scope="scope">
            <div style="vertical-align:middle;line-height:25px;">

              <el-row type="flex" align="middle">
                <el-col :span="2">
                  <!-- <img src="../../assets/logo.png" style="vertical-align: middle;height:40px;" alt=""> -->
                  <!-- <img :src="arr.url" style="vertical-align: middle;height:40px;" /> -->
                  <!-- <img :src="require('../../assets/' + scope.row.logo+ '')" style="vertical-align: middle;height:40px;" alt=""> -->
                  <img :src="'/group/'+ scope.row.groupid +'.png'" style="vertical-align: middle;height:40px;" alt="">
                  
                </el-col>
                <el-col :span="18">
                  
                  <el-row type="flex" align="middle">
                

                    <el-col style="font-size:14px;" >
                      <el-link :underline=false @click="openGroup(scope.row.groupid,'/home/subject');">
                      <span style="font-size:18px;font-weight: bold;margin-bottom:200px;">{{scope.row.name}}</span>
                      &nbsp;
                      <i class="fa fa-sign-in fa-2x"></i> 
                      </el-link>
                      <br>

                      <span style="color:#999">官网：</span><el-link type="primary" :underline="false" :href="'http://'+scope.row.web" target="_blank">{{scope.row.web}}</el-link>
                      <br>
                      <span style="color:#999">地址：</span> {{scope.row.address}}
                
                    </el-col>

                  </el-row>
                  <el-row type="flex" align="middle">
                    <el-col style="font-size:14px;">
                      {{scope.row.description}}
                    </el-col>
                  </el-row>
                  <!-- <el-row type="flex" align="middle" justify="left">
                    <el-col >
                    
                      <el-menu class="el-menu-demo" mode="horizontal" @select="handleSelect"
                      background-color="#ECF5FF"
                      active-text-color="#000"
                      >
                        <el-menu-item  :index='"/home/subject$"+ scope.row.groupid +""' style="font-size:16px;">
                            <i class="fa fa-address-book"></i>&nbsp;
                            <span slot="title">使用者</span>
                          </el-menu-item>
                          
                          <el-menu-item  :index='"/home/project$"+ scope.row.groupid +""' style="font-size:16px;">
                            <i class="fa fa-medkit"></i>&nbsp;
                            <span slot="title">团队研究</span>
                          </el-menu-item>

                      </el-menu>

                      
                    </el-col>
                  
                  </el-row> -->

                </el-col>
                <el-col :span="4" style="text-align:right">
                  <img :src="'/group/groupweixin_'+ scope.row.groupid +'.png'" style="vertical-align: middle;width:150px;" alt="">
                </el-col>
              </el-row>

   
            
            </div>
            
            

  
            <el-pagination
                background
                :hide-on-single-page = "true"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5,10, 20, 30, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next"
                :total="(computedProject(scope.row.projectid).stores || []).length">
            </el-pagination>




           
          </template>
        </el-table-column>
      </el-table>

    </el-main>
    <el-footer style="margin:0px;padding:0px;height:30px;" v-if="filterProjectList.length>3">
      <el-pagination
            background
            
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
            :current-page="currentPage1"
            :page-sizes="[3,5,10,20, 30, 50, 100]"
            :page-size="pageSize1"
            layout="total, sizes, prev, pager, next"
            :total="filterProjectList.length">
        </el-pagination>
    </el-footer>
  </el-container>
</template>

<script>
export default {
    data() {
      return {
        projectList: [],
        loading:true,
        emptytext:"",
        search:'',
        sdcprojects:[],
         // 当前页
        currentPage: 1,
        // 每页多少条
        pageSize: 5,

        currentPage1: 1,
        pageSize1: 3,
        // logo:require('../../assets/logo.png'),
        // arr:{
        //   url: require('../../assets/logo.png'),
        // },

        invitecode:'',
       		
      }
    },
    computed:{
      filterProjectList(){
        var search = this.search;
        var list = this.projectList;
        return list.filter(function (item) {
            return item.name.toLowerCase().indexOf(search.toLowerCase()) != -1
        });
      },
      computedProject(){
        return function(projectid) {
          var sdcproject =[];
          this.sdcprojects.forEach(project => {
            if(project.rootid == projectid){
              sdcproject = project;
            }
          });
          return sdcproject;
        }
      },
    },
    mounted() {
      this.loadList();
      
    },
    methods:{
      loadList() {
            this.loading = true;
            this.emptytext=" ";
            this.$http.get('group/list',{params:{mode:0}}).then((res) => {
              if(!res) return;
              this.projectList = res.data.list;
              this.loading = false;
              this.emptytext = "";
              });                                                  
        },
      reloadList(){
        this.loadList();
        
      },

      
      acceptinvite()
      {
          this.$confirm("确定要接受邀请吗？", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.$http.post('group/acceptinvite', {'invitecode':this.invitecode}).then((res) => {
                  
                  this.$message({ type:'success', message:'欢迎加入《'+ res.data.groupinfo.name +'》团队。'})
                
                  this.invitecode ='';
                  this.loadList();

                  }); 
            });
      },
      openGroup(groupID,url){
        //尝试一次后台对话，然后进行自动跳转
    
        this.$http.get('group/open',{params:{id:groupID+'',url:url}}).then((res) => {
              if(!res) return;
              window.open(res.data.token);
              });
      },


      showfilter(){
        //this.$refs.searchinput.focus();
      },
      handleSelect(index, indexPath) {
        var groupid = index.substring(index.indexOf("$")+1,index.length);
        var menu = index.substring(0,index.indexOf("$"));
        
        // var groupid = indexPath[0].substring(indexPath[0].indexOf("$")+1,indexPath[0].length);
        // //console.log(projectid, index, indexPath);
        this.openGroup(groupid,menu);
      },
      // handleCommand(command){
      //   console.log(command);
      // },
      // handleClick() {
      //   alert('button click');
      // },
      // 每页多少条
      handleSizeChange(val) {
          this.pageSize = val;
      },
      // 当前页
      handleCurrentChange(val) {
          this.currentPage = val;
      },

      // 每页多少条
      handleSizeChange1(val) {
          this.pageSize1 = val;
      },
      // 当前页
      handleCurrentChange1(val) {
          this.currentPage1 = val;
      },

      SelectMoreMenu(index){
        if(index ==2)
        {
          this.delProject()
        }
      },

      flagStar(projectid,starflag){
        this.$http.post('project/flagstar', {'projectid':projectid,'starflag':starflag}).then((res) => { 
          this.loadList();
        }); 
      },

    }
  };
</script>

<style lang="less" scoped>
  /deep/ .el-table tbody tr:hover>td { background-color: #ffffff!important;}
</style>